<template>
  <div class="wrapper">
    <Sidebar :class="!isOpenSidebar ? 'close-sidebar': ''" />
    <div id="wrapper-content" :class="!isOpenSidebar ? 'ml-0' : 'content-wrapper-margin'">
      <PageHeader :isListPage="true" @toggleSidebar="toggleSidebar" />
      <div class="dashboard-wrapper">
        <div class="content-top-bar">
          <div class="row align-items-center">
            <div class="col-sm-3 col-md-6 ">
              <!-- <h5>Sites</h5> -->
              <input v-model="searchText" type="text" class="text-input search-site-text" placeholder="Search Sites by Title or URI">
            </div><!-- 6 -->
            <div class="col-sm-9 col-md-6">
              <div class="content-top-right">
                <div class="form-check">
                  <div class="archive_url">
                    <div class="uri-input-wrapper">
                      <input v-model="siteName" type="text" placeholder="Site URI">
                      <span v-if="checkingUri" class="uri-status uri-checking">checking...</span>
                      <span v-else-if="siteName && uriAvailable === true" class="uri-status uri-available">available</span>
                      <span v-else-if="siteName && uriAvailable === false" class="uri-status uri-taken">URI already taken</span>
                    </div>
                    <a @click.prevent="goToSite(siteName, true)" href="#" class="btn btn-black" :class="{ disabled: !siteName || checkingUri || uriAvailable === false }">Create</a>
                  </div>
                </div>
                <a @click="importSite()" href="#" class="btn btn-default btn-bla ck"><div class="pt-1">Import Site</div></a>
                <div class="form-check">
                  <div class="archiv_btn pointer">
                    <input class="form-check-input"  v-model='archivedOnly' type="checkbox" value="" id="flexCheckChecked">
                    <label class="form-check-label archived-label" for="flexCheckChecked">
                      Archived
                    </label>
                  </div>
                </div>
              </div>
            </div><!-- 6 -->
          </div><!-- row -->
        </div><!-- content-top-bar -->

        <div class="dashboard-table" id="sites-table">
          <div  v-if="loading ||  copying" class="bg-gray-500 bg-opacity-25 fixed top-0 left-0 w-screen h-screen flex items-center justify-center">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div  v-else-if="filteredSites.length === 0" class="h-screen flex items-center justify-center">
            <div class="text-lg">
              {{ archivedOnly ? "No archived sites" : "No sites yet" }}
            </div>
          </div>
          <div>
            <table class="table">
              <tbody>
                <tr v-for="site of filteredSites" :key="site._id">
                  <td>
                    {{ site.title || site.uri }}
                    <span v-if="site.uri">({{ site.uri }})</span>
                  </td>
                  <td>
                    <div class="dashboard-table-icons">
                      <h6>{{ site.defaultQuery }}</h6>
                      <CustomTooltip text="Edit" placement="top">
                        <button
                          class="pointer action-btn"
                          @click="goToSite(site.uri)"
                        >
                          <i class="fa-solid fa-pen-to-square"></i>
                        </button>
                      </CustomTooltip>
                      <!-- <a data-bs-toggle="tooltip" data-bs-placement="bottom"
												data-bs-title="Permission" ><i class="fa-solid fa-key"></i></a> -->

                      <!-- View Button -->
                      <CustomTooltip text="View" placement="top">
                        <button class="pointer action-btn" @click="openSitePage(site)">
                          <i class="fa-solid fa-eye"></i>
                        </button>
                      </CustomTooltip>

                      <!-- Copy Button -->
                      <CustomTooltip text="Copy" placement="top">
                        <button class="pointer action-btn" @click="dupSite(site)">
                          <i class="fa-solid fa-copy"></i>
                        </button>
                      </CustomTooltip>

                      <!-- Archive Button -->
                      <CustomTooltip text="Archive" placement="top">
                        <button class="pointer action-btn" @click="archive(site)">
                          <i class="fa-solid fa-box-archive"></i>
                        </button>
                      </CustomTooltip>

                      <!-- Export Button -->
                      <CustomTooltip
                        :text="exportingSiteId === site._id ? 'Exporting...' : 'Export'"
                        :key="`tooltip-export-${site._id}-${exportingSiteId === site._id}`"
                        placement="top"
                      >
                        <button
                          class="pointer action-btn"
                          @click="exportSite(site)"
                          :disabled="exportingSiteId === site._id"
                        >
                          <i v-if="exportingSiteId !== site._id" class="fa fa-cloud-download" aria-hidden="true"></i>
                          <i v-else class="fa-solid fa-spinner fa-spin"></i>
                        </button>
                      </CustomTooltip>

                      <!-- Audit Logs Button -->
                      <CustomTooltip text="Audit Logs" placement="top">
                        <button class="pointer action-btn" @click="viewAuditLogs(site)">
                          <i class="fa-solid fa-clipboard-list"></i>
                        </button>
                      </CustomTooltip>
                    </div>
                    <!-- dashboard-table-icons -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <nav aria-label="Page navigation">
						<ul class="pagination justify-content-center mb-0">
							<li class="page-item disabled">
								<a class="page-link"><i class="fa-solid fa-chevron-left"></i></a>
							</li>
							<li class="page-item"><a class="page-link" href="#">1</a></li>
							<li class="page-item"><a class="page-link" href="#">2</a></li>
							<li class="page-item"><a class="page-link" href="#">3</a></li>
							<li class="page-item">
								<a class="page-link" href="#"><i class="fa-solid fa-chevron-right"></i></a>
							</li>
						</ul>
					</nav> -->
        </div><!-- dashboard-table -->

      </div><!-- dashboard-wrapper -->
    </div>
    <ImportSite v-if="isDisplayImportModal" @onCloseImportModal="onCloseImportModal" />
    <VersionSelectionModal
      :isVisible="showVersionModal"
      :versions="siteVersions"
      modalTitle="Select Versions to Export"
      actionText="Export"
      @confirm="handleExportVersionSelection"
      @cancel="handleExportVersionCancel"
    />
  </div>
</template>
<script>
import PageHeader from './components/PageHeader'
import Sidebar from '@/components/Sidebar.vue'
import * as siteService from '../service/site'
import { viewer_url } from '../constants'
import ImportSite from '../components/ImportSite.vue'
import CustomTooltip from "@/utilities/CustomTooltip.vue";
import VersionSelectionModal from '../components/VersionSelectionModal.vue';

export default {
  name: 'SitesList',
  components: {
    PageHeader,
    Sidebar,
    ImportSite,
    CustomTooltip,
    VersionSelectionModal,
  },
  data () {
    return {
      loading: false,
      siteName: '',
      uriAvailable: null,
      checkingUri: false,
      uriCheckTimeout: null,
      sites: [],
      copying: false,
      archivedOnly: false,
      searchText: '',
      isOpenSidebar: true,
      isDisplayImportModal: false,
      // Export version-selection state
      showVersionModal: false,
      siteVersions: [],
      exportingSiteId: null, // Track which specific site is being exported
      currentExportSite: null,
    }
  },
  mounted () {
    this.loadData()
  },
  watch: {
    archivedOnly () {
      this.loadData()
    },
    siteName (val) {
      this.uriAvailable = null
      clearTimeout(this.uriCheckTimeout)
      if (!val) { this.checkingUri = false; return }
      this.checkingUri = true
      this.uriCheckTimeout = setTimeout(async () => {
        try {
          const result = await siteService.checkSiteUri(val)
          this.uriAvailable = result.available
        } catch (e) {
          this.uriAvailable = null
        }
        this.checkingUri = false
      }, 400)
    }
  },
  computed:{
    filteredSites(){
      let search = this.searchText.trim().toLowerCase();
      if (search) {
        return this.sites.filter(site => site?.title?.toLowerCase()?.includes(search) || site?.uri?.toLowerCase()?.includes(search))
      }
      return this.sites;
    }
  },
  methods: {
    async loadData () {
      this.loading = true
      try {
        this.sites = await siteService.getSites(this.archivedOnly)
      } catch (err) {
        console.log('err: ', err);
      }
      this.loading = false
    },
    goToSite (name, create = false) {
      if (!name) { return }
      if (create && (this.checkingUri || this.uriAvailable === false)) { return }
      const query = create ? '?create=true' : ''
      // Use location.href here to force a full load (consistent with existing code)
      window.location.href = `/site-edit/${name}${query}`
    },
    openSitePage (site) {
      const defaultQuery = typeof site.defaultQuery === 'string' ? site.defaultQuery.trim() : ''
      const query = defaultQuery ? `?${defaultQuery}` : ''
      const url = `${viewer_url}/${site.uri}${query}`
      window.open(url)
    },
    async archive (site) {
      const confirm = window.confirm(`Are you sure want to archive ${site.uri}?`)
      if (!confirm) { return }
      await siteService.archiveSite(site.uri)
      this.loadData()
    },

    async exportSite(site){
      this.currentExportSite = site

      try {
        this.exportingSiteId = site._id // Indicate versions are loading for this site
        const versionsResponse = await siteService.getSiteVersions(site.uri)
        this.siteVersions = this.processVersionsData(versionsResponse)
        this.showVersionModal = true
      } catch (err) {
        console.log("err", err)
        this.$notify({
          type: "error",
          text: "Unable to fetch versions for this site.",
        });
        this.resetExportState()
      } finally {
        this.exportingSiteId = null // Clear loading state after versions fetched
      }
    },

    async handleExportVersionSelection(selectedVersions) {
      this.showVersionModal = false
      if (!this.currentExportSite || !selectedVersions || selectedVersions.length === 0) {
        this.resetExportState()
        return
      }

      this.loading = true
      try {
        let data = await siteService.exportSite(this.currentExportSite.uri, selectedVersions)

        // Create a blob from the JSON data
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' })

        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob)

        // Create a temporary link element
        const link = document.createElement('a')
        link.href = url
        link.download = `${this.currentExportSite.uri}-export.json`

        // Trigger the download
        document.body.appendChild(link)
        link.click()

        // Clean up
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (err) {
        console.log('err: while exporting', err);
        this.$notify({
          type: "error",
          text: err.error || 'Error while exporting site',
        });
      } finally {
        this.loading = false
        this.resetExportState()
      }
    },

    handleExportVersionCancel() {
      this.showVersionModal = false
      this.resetExportState()
    },

    /**
     * Processes raw version data from the API into a format suitable for the version selection modal.
     * Maps version information and determines which versions are current and published.
     */
    processVersionsData(rawData) {
      if (!rawData || !rawData.versions) return []
      return rawData.versions.map(version => ({
        version: version,
        is_current: version === rawData.current_version,
        is_published: version === rawData.published_version
      }))
    },

    resetExportState() {
      this.currentExportSite = null
      this.siteVersions = []
      this.exportingSiteId = null
    },

    importSite(){
      this.isDisplayImportModal = true;
    },

    onCloseImportModal(isLoadData = false){
      this.isDisplayImportModal = false;
      if (isLoadData) {
        this.loadData();
      }
    },
    async unArchive (site) {
      await siteService.unArchiveSite(site.uri)
      this.loadData()
    },
    async dupSite (site) {
      this.copying = true
      const newSiteUri = window.prompt('New Site Uri', `${site.uri}-copy`)
      try {
        await siteService.duplicateSite(site.uri, newSiteUri)
        this.loadData()
      } catch (err) {
        this.$notify({
          type: "warn",
          text: 'URI is already used. please use new uri',
        });
      }
      this.copying = false
    },
    viewAuditLogs(site) {
      const siteId = site.site_id || site._id
      if (!siteId) {
        this.$notify({ type: 'warn', text: 'Unable to open audit logs: site id missing.' })
        return
      }
      this.$router.push(`/audit-logs/${siteId}/${site.uri}`)
    },
    toggleSidebar(){
      this.isOpenSidebar = !this.isOpenSidebar
    }
  }
}
</script>
<style>
.close-sidebar{
  margin-left: -260px !important;
}
.search-site-text{
  width: 100%;
  max-width: 300px;
}
.archived-label{
  margin-left: 4px;
}
#sites-table{
  height: calc(100vh - 156px);
  overflow: auto;
}
</style>